<!-- 咨询服务二级页面 -->
<template>
  <div class="home animate__animated animate__fadeIn">
    <div class="top">
      <Header />
    </div>
    <div class="banner">
      <div class="animate__animated animate__fadeInUp animate__faster">
        <span style="margin-bottom:20px">咨询服务</span>
        <span>
          专注各自擅长的领域
          <br />提供可用性、盈利能力和安全性的咨询、服务和技术
        </span>
      </div>
    </div>
    <div class="main">
      <div class="main_center">
        <div class="bread">
          <span style="cursor:pointer" @click="handleHome">首页</span> > 咨询服务
        </div>
        <div class="title">提高机器、设备和技术方面的投资价值</div>
        <div class="text">
          我们的咨询服务汇集了行业、技术、运营和应用方面的专业知识和资深专家，旨在实现安全、可靠、高效的制造。我们提供全方位的工业自动化服务，从开始到升级改造，我们通过专业技术人员和现场运维服务，确保并且（在理想情况下）提高机器与工厂的可用性和生产力。
          <br />我们可以帮助客户提供咨询与实施的各类解决方案，解决您的业务挑战和实现业务目标，从而优化您的产品、服务和企业。不管是需要咨询、设计、评估、实施方面的支持还是需要长期维护，我们所有阶段都能提供有价值的帮助。
        </div>
        <ul>
          <li
            v-for="(item,index) in imgList"
            :key="index"
            @mouseenter="handleEnter(index)"
            @mouseleave="handleLeave(index)"
            @click="handleClick(index)"
          >
            <img v-bind:src="item.url" class="animate__animated" alt />
            <div class="name animate__animated animate__headShake" v-if="item.spanFlag">
              <span>{{item.name}}</span>
            </div>
            <div class="mask animate__animated animate__fadeIn" v-if="item.maskFlag">
              <div>
              <span class="animate__animated animate__lightSpeedInLeft">{{item.name}}</span>
              <span
                class="animate__animated animate__lightSpeedInLeft"
              >{{item.content}}</span></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "@components/header";
import Footer from "@components/footer";
export default {
  name: "Consulting",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      headerList: [
        { name: "解决方案" },
        { name: "产品中心" },
        { name: "咨询服务" },
        { name: "专长" },
        { name: "了解我们" },
        { name: "加入我们" },
      ],
      jieList: [
        { name: "自动化", link: "" },
        { name: "物联", link: "" },
        { name: "能源", link: "" },
        { name: "环境", link: "" },
      ],
      chanList: [
        {
          name: "工业无线",
          detail: [
            { name: "无线网络", link: "" },
            { name: "无线通讯", link: "" },
            { name: "无线位置", link: "" },
            { name: "无限分析", link: "" },
          ],
        },
        {
          name: "工业软件",
          detail: [
            { name: "能源管理软件", link: "" },
            { name: "大数据平台", link: "" },
            { name: "GIS地图信息平台", link: "" },
          ],
        },
        {
          name: "测量仪表",
          detail: [
            { name: "流体仪表", link: "" },
            { name: "电力仪表", link: "" },
            { name: "压力仪表", link: "" },
            { name: "温度仪表", link: "" },
            { name: "液位仪表", link: "" },
          ],
        },
      ],
      ziList: [
        {
          name: "咨询",
          detail: [
            { name: "智能工厂设计咨询", link: "" },
            { name: "工业物联园区设计咨询", link: "" },
          ],
        },
        {
          name: "服务",
          detail: [
            { name: "设备安装与运维服务", link: "" },
            { name: "数据分析与校准服务", link: "" },
            { name: "能源与能效诊断服务", link: "" },
          ],
        },
      ],
      zhuanList: [
        { name: "跨学科研发", link: "" },
        { name: "物联", link: "" },
        { name: "工业无线", link: "" },
        { name: "流体测量", link: "" },
      ],
      liaoList: [
        { name: "企业概述", link: "" },
        { name: "企业文化", link: "" },
        { name: "荣誉资质", link: "" },
        { name: "新闻报告", link: "" },
        { name: "合作伙伴", link: "" },
      ],
      jiaList: [
        { name: "社会招聘", link: "" },
        { name: "校园招聘", link: "" },
      ],
      headerFlag: true,
      img1before: require("@assets/img/logob.png"),
      img2before: require("@assets/img/soub.png"),
      img3before: require("@assets/img/daob.png"),
      activeIndex: -1,
      modalFlag: false,
      rotate: false, //控制互转效果
      erweima: require("@assets/img/erma.png"),
      //   banner: require("@assets/img/banner2.jpg"),
      imgList: [
        {
          name: "咨询",
          url: require("@assets/img/er_zixun.png"),
          spanFlag: true,
          maskFlag: false,
          href: "/consultSer",
          content:"尖端技术加上高度灵活的方式方法，与客户在项目的各个阶段实现通力合作，提供可靠保障。无论是新建或者改造，我们都与客户携手，定制理想的解决方案。"
        },
        {
          name: "服务",
          url: require("@assets/img/er_fuwu.png"),
          spanFlag: true,
          maskFlag: false,
          href: "/servicing",
          content:"我们提供可扩展的项目交付方法和完善的项目管理服务，不局限安装、校准、维护和更换机器和系统，从驱动器系统实施到完整的逻辑网络实施再到整个系统的现代化，我们都能做到。"
        },
      ],
      spanFlag: true,
    };
  },
  methods: {
    handleToHome() {
      //点击图片跳转到首页
      this.$router.push("/");
      // console.log(123);
    },
    enter: function () {
      this.headerFlag = false;
      this.img1before = require("@assets/img/logob.png");
      this.img2before = require("@assets/img/soub.png");
      this.img3before = require("@assets/img/daob.png");
      this.activeIndex = -1;
    },
    leave: function () {
      this.headerFlag = true;
      this.img1before = require("@assets/img/logob.png");
      this.img2before = require("@assets/img/soub.png");
      this.img3before = require("@assets/img/daob.png");
      this.activeIndex = -1;
    },
    selected(index) {
      this.activeIndex = index;
      // console.log(this.activeIndex);
    },
    navShow() {
      // console.log(index);
    },
    navNone() {
      // console.log(index);
    },
    afterLoad() {},
    showAll() {
      //打开弹窗
      //点击右上角三条横杠
      this.modalFlag = true;
      // var mo=function(e){e.preventDefault();};
      //   document.body.style.overflow='hidden';
      //   document.addEventListener("touchmove",mo,false);//禁止页面滑动
      // this.$refs.fullpage.api.setAllowScrolling(false, "up,down,left, right");
    },
    handleClose() {
      //关闭弹窗
      this.modalFlag = false;
      // this.$refs.fullpage.api.setAllowScrolling(true, "up,down,left, right");
    },
    zhuan() {
      //旋转模态框叉号
      this.rotate = !this.rotate;
    },
    // 面包屑
    handleHome() {
      this.$router.push("/");
    },
    handleEnter(index) {
      //滑上组件时字体消失 遮罩显示
      // this.spanFlag=false;
      // console.log(index)
      this.imgList[index].spanFlag = false;
      this.imgList[index].maskFlag = true;
    },
    handleLeave(index) {
      // console.log(index)
      this.imgList[index].spanFlag = true;
      this.imgList[index].maskFlag = false;
    },
    // 跳转三级页面
    handleClick(index) {
      this.$router.push(this.imgList[index].href);
    },
  },
};
</script>

<style lang='scss' scoped>
.home {
  width: 100%;
  height: 100%;
  position: relative;
}
.banner {
  width: 100%;
  height: 500px;
  background: url("../../assets/img/banner4.jpg") no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: bottom center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  div {
    width: 75%;
    margin: 0 auto;
  }
  span {
    font-size: 26px;
    font-family: YaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    display: block;
    // margin-left: 20%;
    line-height: 44px;
    letter-spacing: 2px;
    &:nth-child(1) {
      font-size: 48px;
      font-family: YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      letter-spacing: 4px;
      // padding-top: 15%;
      // padding-bottom: 18px;
    }
  }
}
.main {
  width: 100%;
  padding-bottom: 60px;
  // height: 933px;
  background: #f5f5f5;
  .main_center {
    width: 75%;
    // height: 100%;
    margin: 0 auto;
    .bread {
      padding-top: 30px;
      font-size: 16px;
      font-family: YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      cursor: default;
    }
    .title {
      font-size: 48px;
      font-family: YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      padding-top: 104px;
    }
    .text {
      // width: 76%;
      margin: 0 auto;
      font-size: 24px;
      line-height:44px;
      font-family: YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      padding-top: 33px;
      text-align: center;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      padding-top: 124px;
      li {
        cursor: pointer;
        position: relative;
        width: 380px;
        height: 310px;
        background: rgba(255, 255, 255, 1);
        overflow: hidden;
        // border: 1px dashed rgba(51, 51, 51, 1);
        margin-right: 140px;
        margin-bottom: 44px;
        img {
          width: 380px;
          height: 310px;
          // position: absolute;
          // transition: all 3s;
          // &:hover {
          //   transform: scale(
          //     1.1
          //   ); /*scale:图片放大几倍；translateX,translateY:放大后图片的位移*/
          //   // border: 1px solid #999;
          // }
        }
        &:nth-child(3) {
          margin-right: 0px;
        }
        .name {
          position: absolute;
          bottom: 0;
          width: 380px;
          height: 76px;
          background: rgba(255, 255, 255, 1);
          // transition: all 3s;
          span {
            font-size: 30px;
            font-family: Source Han Sans SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            line-height: 76px;
            margin-left: 24px;
          }
        }
        //  &:hover .name{
        //    display: none;
        //    position: relative;
        //    transition: all 3s;
        //  }
        .mask {
          width: 380px;
          height: 310px;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background: rgba(51, 51, 51, 0.5);
          // opacity: 0.5;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          // span {
          //   display: block;
          //   width: 83%;
          //   &:nth-child(1) {
          //     // margin: 50px 35px 32px;
          //     font-size: 30px;
          //     font-family: YaHei;
          //     font-weight: 400;
          //     color: rgba(255, 255, 255, 1);
          //      margin-bottom: 25px;
          //   }
          //   &:nth-child(2) {
          //     font-size: 18px;
          //     font-family: YaHei;
          //     font-weight: 400;
          //     color: rgba(255, 255, 255, 1);
          //     // margin-left: 35px;
          //   }
          // }
             span {
            display: block;
            &:nth-child(1) {
              // margin: 60px 35px 32px;
              font-size: 30px;
              font-family: YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              margin-bottom: 25px;
            }
            &:nth-child(2) {
              font-size: 18px;
              font-family: YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              // margin-left: 35px;
              width: 306px;
            }
          }
        }
      }
    }
  }
}
</style>
